<template>
  <div class="text-center">
    <header class="page-games__header">
      <div
        class="page-games__date text-caption text-uppercase q-py-sm text-bold text-primary"
      >
        <p>{{ formatDate(edtDate, 'dddd') }}</p>
        <p>{{ formatDate(edtDate, 'MMMM D, YYYY') }}</p>
      </div>
      <h1
        class="page-games__title text-h5 text-center text-primary text-uppercase text-bold"
      >
        {{ $t('titles.available_games') }}
      </h1>
    </header>
    <div class="page-games__content q-py-sm">
      <template v-if="Array.isArray(games)">
        <template v-if="hasGames">
          <template v-if="gamesByDate.today.length">
            <q-list class="q-px-sm">
              <q-item
                :to="{
                  name: 'game',
                  params: { id: game.id },
                }"
                v-for="(game, index) in gamesByDate.today"
                :key="game.id"
                :class="{
                  'q-mt-sm': index > 0,
                  [getGameColor(game.status)]: true,
                }"
                class="text-center shadow-2 rounded-borders"
                clickable
                ripple
              >
                <q-item-section avatar>
                  <q-img
                    :src="getLogoUrl(game.awayTeam.abbreviation)"
                    :ratio="1"
                    :alt="game.awayTeam.abbreviation"
                    :contain="true"
                  />
                </q-item-section>
                <q-item-section>
                  <q-item-label
                    v-if="game.status !== GAME_STATUSES.SCHEDULED"
                    caption
                    class="text-bold text-uppercase text-white"
                  >
                    <template v-if="+activeGameId === +game.id">
                      {{ $t('statuses.your_active_game') }}
                    </template>
                    <template v-else>
                      {{ game.status }}
                    </template>
                  </q-item-label>
                  <q-item class="q-pa-none q-pb-sm">
                    <q-item-section class="text-right">
                      <q-item-label
                        overline
                        class="text-white"
                      >
                        <p>{{ game.awayTeam.city }}</p>
                        <p class="text-bold">
                          {{ game.awayTeam.name }}
                        </p>
                      </q-item-label>
                    </q-item-section>
                    <q-item-section class="col-1 text-white text-bold">
                      {{ $t('@') }}
                    </q-item-section>
                    <q-item-section class="text-left">
                      <q-item-label
                        overline
                        class="text-white"
                      >
                        <p>{{ game.homeTeam.city }}</p>
                        <p class="text-bold">
                          {{ game.homeTeam.name }}
                        </p>
                      </q-item-label>
                    </q-item-section>
                  </q-item>
                  <q-item-label
                    caption
                    class="text-bold text-indigo-1"
                  >
                    {{ game.location }} -
                    {{ getEdtDate(game.startDate, 'h:mma [EDT]') }}
                  </q-item-label>
                </q-item-section>
                <q-item-section avatar>
                  <q-img
                    :src="getLogoUrl(game.homeTeam.abbreviation)"
                    :ratio="1"
                    :alt="game.awayTeam.abbreviation"
                    :contain="true"
                  />
                </q-item-section>
              </q-item>
            </q-list>
          </template>
          <template v-if="gamesByDate.yesterday.length">
            <h2
              class="page-games__title text-h5 text-center text-primary text-uppercase text-bold q-pb-sm q-pt-md"
            >
              {{ $t('titles.yesterdays_games') }}
            </h2>
            <q-list class="q-px-sm">
              <q-item
                :to="{
                  name: 'game',
                  params: { id: game.id },
                }"
                v-for="(game, index) in gamesByDate.yesterday"
                :key="game.id"
                :class="{
                  'q-mt-sm': index > 0,
                  [getGameColor(game.status)]: true,
                }"
                class="text-center shadow-2 rounded-borders"
                clickable
                ripple
              >
                <q-item-section avatar>
                  <q-img
                    :src="getLogoUrl(game.awayTeam.abbreviation)"
                    :ratio="1"
                    :alt="game.awayTeam.abbreviation"
                    :contain="true"
                  />
                </q-item-section>
                <q-item-section>
                  <q-item-label
                    v-if="game.status !== GAME_STATUSES.SCHEDULED"
                    caption
                    class="text-bold text-uppercase text-white"
                  >
                    <template v-if="+activeGameId === +game.id">
                      {{ $t('statuses.your_active_game') }}
                    </template>
                    <template v-else>
                      {{ game.status }}
                    </template>
                  </q-item-label>
                  <q-item class="q-pa-none q-pb-sm">
                    <q-item-section class="text-right">
                      <q-item-label
                        overline
                        class="text-white"
                      >
                        <p>{{ game.awayTeam.city }}</p>
                        <p class="text-bold">
                          {{ game.awayTeam.name }}
                        </p>
                      </q-item-label>
                    </q-item-section>
                    <q-item-section class="col-1 text-white text-bold">
                      {{ $t('@') }}
                    </q-item-section>
                    <q-item-section class="text-left">
                      <q-item-label
                        overline
                        class="text-white"
                      >
                        <p>{{ game.homeTeam.city }}</p>
                        <p class="text-bold">
                          {{ game.homeTeam.name }}
                        </p>
                      </q-item-label>
                    </q-item-section>
                  </q-item>
                  <q-item-label
                    caption
                    class="text-bold text-indigo-1"
                  >
                    {{ game.location }} -
                    {{ getEdtDate(game.startDate, 'h:mma [EDT]') }}
                  </q-item-label>
                </q-item-section>
                <q-item-section avatar>
                  <q-img
                    :src="getLogoUrl(game.homeTeam.abbreviation)"
                    :ratio="1"
                    :alt="game.awayTeam.abbreviation"
                    :contain="true"
                  />
                </q-item-section>
              </q-item>
            </q-list>
          </template>
          <template v-if="gamesByDate.tomorrow.length">
            <h2
              class="page-games__title text-h5 text-center text-primary text-uppercase text-bold q-pb-sm q-pt-md"
            >
              {{ $t('titles.tomorrows_games') }}
            </h2>
            <q-list class="q-px-sm">
              <q-item
                :to="{
                  name: 'game',
                  params: { id: game.id },
                }"
                v-for="(game, index) in gamesByDate.tomorrow"
                :key="game.id"
                :class="{
                  'q-mt-sm': index > 0,
                  [getGameColor(game.status)]: true,
                }"
                class="text-center shadow-2 rounded-borders"
                clickable
                ripple
              >
                <q-item-section avatar>
                  <q-img
                    :src="getLogoUrl(game.awayTeam.abbreviation)"
                    :ratio="1"
                    :alt="game.awayTeam.abbreviation"
                    :contain="true"
                  />
                </q-item-section>
                <q-item-section>
                  <q-item-label
                    v-if="game.status !== GAME_STATUSES.SCHEDULED"
                    caption
                    class="text-bold text-uppercase text-white"
                  >
                    <template v-if="+activeGameId === +game.id">
                      {{ $t('statuses.your_active_game') }}
                    </template>
                    <template v-else>
                      {{ game.status }}
                    </template>
                  </q-item-label>
                  <q-item class="q-pa-none q-pb-sm">
                    <q-item-section class="text-right">
                      <q-item-label
                        overline
                        class="text-white"
                      >
                        <p>{{ game.awayTeam.city }}</p>
                        <p class="text-bold">
                          {{ game.awayTeam.name }}
                        </p>
                      </q-item-label>
                    </q-item-section>
                    <q-item-section class="col-1 text-white text-bold">
                      {{ $t('@') }}
                    </q-item-section>
                    <q-item-section class="text-left">
                      <q-item-label
                        overline
                        class="text-white"
                      >
                        <p>{{ game.homeTeam.city }}</p>
                        <p class="text-bold">
                          {{ game.homeTeam.name }}
                        </p>
                      </q-item-label>
                    </q-item-section>
                  </q-item>
                  <q-item-label
                    caption
                    class="text-bold text-indigo-1"
                  >
                    {{ game.location }} -
                    {{ getEdtDate(game.startDate, 'h:mma [EDT]') }}
                  </q-item-label>
                </q-item-section>
                <q-item-section avatar>
                  <q-img
                    :src="getLogoUrl(game.homeTeam.abbreviation)"
                    :ratio="1"
                    :alt="game.awayTeam.abbreviation"
                    :contain="true"
                  />
                </q-item-section>
              </q-item>
            </q-list>
          </template>
        </template>
        <div
          v-else
          class="text-center"
        >
          {{ $t('titles.no_games') }}
        </div>
      </template>
      <template v-else>
        <div class="text-center">
          {{ $t('titles.wait') }}
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { format } from 'date-fns';
import edtDate from '@/helpers/edt-date';
import { GAME_STATUSES } from '@/helpers';
import { mapGetters } from 'vuex';

const STATUSES_ORDER = [
  GAME_STATUSES.LIVE,
  GAME_STATUSES.SCHEDULED,
  GAME_STATUSES.COMPLETED,
];

import ListGamesItem from '@/components/common/ListGamesItem';

@Component({
  name: 'page-games',
  components: {
    ListGamesItem,
  },
  computed: mapGetters(['activeGameId', 'games']),
})
export default class PageGames extends Vue {
  // !DATA
  GAME_STATUSES = GAME_STATUSES;

  get hasGames() {
    return Array.isArray(this.games) && this.games.length > 0;
  }
  get edtDate() {
    return edtDate(new Date(), 'raw');
  }
  get gamesByDate() {
    const today = this.getEdtDate(new Date(), 'YYYY.MM.DD');
    const result = {
      yesterday: [],
      today: [],
      tomorrow: [],
    };

    // STATUSES_ORDER

    if (!this.games) return;

    this.games.forEach(game => {
      const gameDate = this.getEdtDate(game.startDate, 'YYYY.MM.DD');
      if (gameDate === today) {
        result.today.push(game);
      } else if (gameDate < today) {
        result.yesterday.push(game);
      } else if (gameDate > today) {
        result.tomorrow.push(game);
      }
    });
    Object.keys(result).forEach(day => {
      result[day] = this.sortGamesByStatus(result[day]);
    });
    return result;
  }
  get gamesSorted() {
    return this.games.slice().sort((a, b) => {
      if (STATUSES_ORDER.indexOf(a.status) > STATUSES_ORDER.indexOf(b.status)) {
        return 1;
      } else if (
        STATUSES_ORDER.indexOf(a.status) < STATUSES_ORDER.indexOf(b.status)
      ) {
        return -1;
      } else if (
        new Date(a.startDate).getTime() < new Date(b.startDate).getTime()
      ) {
        return -1;
      } else if (
        new Date(a.startDate).getTime() > new Date(b.startDate).getTime()
      ) {
        return 1;
      } else {
        return 0;
      }
    });
  }

  // !METHODS
  sortGamesByStatus(array) {
    return array.slice().sort((a, b) => {
      if (STATUSES_ORDER.indexOf(a.status) > STATUSES_ORDER.indexOf(b.status)) {
        return 1;
      } else if (
        STATUSES_ORDER.indexOf(a.status) < STATUSES_ORDER.indexOf(b.status)
      ) {
        return -1;
      } else if (
        new Date(a.startDate).getTime() < new Date(b.startDate).getTime()
      ) {
        return -1;
      } else if (
        new Date(a.startDate).getTime() > new Date(b.startDate).getTime()
      ) {
        return 1;
      } else {
        return 0;
      }
    });
  }
  getGameColor(status) {
    switch (status) {
      case GAME_STATUSES.SCHEDULED:
        return 'bg-secondary';
      case GAME_STATUSES.LIVE:
        return 'bg-primary';
      case GAME_STATUSES.COMPLETED:
        return 'bg-grey';
    }
  }
  getEdtDate(date, template) {
    return edtDate(date, template);
  }
  formatDate(date, template = 'h:mma') {
    return format(date, template);
  }
  getLogoUrl(name) {
    return `${this.$appConfig.bucket_url}/${name.toLowerCase()}.svg`;
  }
}
</script>
<style lang="stylus">
.page-games {
  &__header {
    padding-right: 5px + 42px + 5px;
    padding-left: 5px + 42px + 5px;
  }
  &__date {
    p + p {
      // margin-top: 0.5em;
    }
  }
}
</style>
<i18n>
{
  "en": {
    "titles": {
      "available_games": "Available Games",
      "yesterdays_games": "Yesterday's Games",
      "tomorrows_games": "Tomorrow's Games",
      "no_games": "No games available today!",
      "wait": "Please, wait..."
    },
    "statuses": {
      "your_active_game": "Your active game"
    }
  }
}
</i18n>
